module.exports = __webpack_public_path__ + "img/top-explanation01.79f35146.png";